module.exports = __webpack_public_path__ + "fonts/Ubuntu-LightItalic.ed3c12f.ttf";